import { vnTemplate } from "./vnTemplate";
export class infoButton_template extends vnTemplate {
    getTemplateHtml() {
        return `
            <div data-bind="" style="position: relative">
                <!-- ko ifnot: buttonLabel -->
                    <button type="button" class="open-button icon i-help" data-bind="event: { click: onClickToggle }"></button>
                <!-- /ko -->
                <!-- ko if: buttonLabel -->
                    <button type="button" class="open-button" data-bind="text: buttonLabel, event: { click: onClickToggle }"></button>
                <!-- /ko -->
                <div class="tooltips-adv" data-bind="visible: isVisible" >      
                    <h3 class="tooltips-adv-title " data-bind="text: title"></h3>
                    <div class="tooltips-adv-content" data-bind="html: visibleContent"></div>
                    <button type="button" class="close-button icon i-x-after" data-bind="event: { click: onClickClose }"></button>
                </div>
            </div>
        `;
    }
    /**
     * @inheritDoc
     */
    getTemplateName() {
        return 'infoButton-template';
    }
    /**
     * @inheritDoc
     */
    getMainElementClasses() {
        return ['infoButton'];
    }
    /**
     * @inheritDoc
     */
    buildViewModel() {
        let self = this;
        return {
            isVisible: ko.observable(false),
            buttonLabel: ko.observable(''),
            title: ko.observable(''),
            content: ko.observable(''),
            visibleContent: ko.observable(''),
            onClickToggle: function () { self.toggleVisibility(this); },
            onClickClose: function () { this.isVisible(false); },
        };
    }
    //
    // Sets the button label.
    setButtonLabel(buttonLabel) {
        this.getTemplateViewModel().buttonLabel(buttonLabel);
    }
    //
    // Sets the title.
    setTitle(title) {
        this.getTemplateViewModel().title(title);
    }
    //
    // Sets the content.
    setContent(content) {
        this.getTemplateViewModel().content(content);
    }
    //
    // Hides tooltip.
    hide() {
        this.getTemplateViewModel().isVisible(false);
    }
    //
    // Toggle tooltip.
    toggleVisibility(viewModel) {
        if (this.viewModel.lastButtonClicked && this.viewModel.lastButtonClicked !== this.idElement) {
            this.viewModel[this.viewModel.lastButtonClicked].isVisible(false);
        }
        if ('' === viewModel.visibleContent() || viewModel.visibleContent() !== viewModel.content()) {
            viewModel.visibleContent(viewModel.content());
        }
        viewModel.isVisible(!viewModel.isVisible());
        this.viewModel.lastButtonClicked = this.idElement;
    }
}
